import Router                          from "next/router";
import { useEffect, useRef, useState } from "react";

import {
	useGetIsBlockedByStreamer,
	useGetTheatreMode,
	useSetTheatreMode
} from "_common/hooks/global";
import { useSetPipMode }                            from "_common/hooks/player";
import { useGetTotalReactions, useSetSessionEnded } from "_common/hooks/stream";
import { useGetDynamicData }                        from "_components/features/ivsChat/states";
import { STREAM_TIER }                              from "_components/pages/proPage/constants";
import { useGetUpdateSession }                      from "_jotai/liveSession";
import {
	sendBroadcastClickStreamEngagement
} from "_services/api/engagement";
// import throttle                                                                            from "lodash/throttle";

import Presentation   from "./presentation";
import { useLSWatch } from "./useLSWatch";

const component = props => {
	const {
		isStreamer,
		broadcastId
	} = props;

	const data                 = useGetUpdateSession ();
	const isBlockedByStreamer  = useGetIsBlockedByStreamer ();
	const totalReactions       = useGetTotalReactions ();
	const streamHasEnded       = useRef ( false );
	const interval             = useRef ( null );
	const setToggleTheatreMode = useSetTheatreMode ();
	const theatreModeToggle    = useGetTheatreMode ();
	const togglePipModeVideo   = useSetPipMode ();
	const setSessionEnded      = useSetSessionEnded ();
	const dynamicData          = useGetDynamicData ();
	const isSessionEnded       = data?.endTimeUTC ? true : false;

	// console.log ( "-=---------============", data );

	const [ staticTotalReactions, setStaticTotalReactions ] = useState ( 0 );
	const [ staticTotalComments, setStaticTotalComments ]   = useState ( 0 );

	useLSWatch ( {
		broadcastId,
		streamTier: data?.streamTier,
		streamHasEnded,
		interval,
		isSessionEnded
	} );

	useEffect ( () => {
		Router.events.on ( "routeChangeComplete", disableTheatreMode );

		handlePipMode ( false ); // On initial load we still need to close PIP

		return () => {
			Router.events.off ( "routeChangeComplete", disableTheatreMode );
		};
	}, [] );

	useEffect ( () => {
		/*
      Don't show PIP on broadcast stream change.

      No need for early return otherwise PIP will show and then close.
    */
		handlePipMode ( false );

		return () => {
			/*
        Mount PIP only when we have graphql stream data
      */
			if ( !isStreamer )
				handlePipMode ( true );
		};
	}, [ data ] );

	useEffect ( () => {
		sendBroadCastClickEvent ();
		setStaticTotalReactions ( 0 );
		setStaticTotalComments ( 0 );
		setSessionEnded ( false );
		clearInterval ( interval.current );

		return () => {
			clearInterval ( interval.current );
		};
	}, [ broadcastId ] );

	useEffect ( () => {
		if ( !data )
			return;

		setStaticTotalReactions ( data.totalReactions );
		setStaticTotalComments ( data.totalComments );

		if ( data.endTimeUTC && interval.current )
			return clearInterval ( interval.current );

		// for recorded sessions, fetch from graphql else fetch from firestore
		if ( data.endTimeUTC )
			return setSessionEnded ( true );

		if ( theatreModeToggle )
			handleTheatreMode ();
	}, [ data ] );

	useEffect ( () => {
		if ( data?.endTimeUTC || !dynamicData.cdnUrl )
			return;

		if ( dynamicData.hasEnded ) {
			setSessionEnded ( true );
			streamHasEnded.current = true;

			if ( interval.current )
				clearInterval ( interval.current );
		}

	}, [ dynamicData ] );

	const sendBroadCastClickEvent = async () => {
		try {
			const params = {
				liveSessionId : broadcastId,
				isLive        : isSessionEnded ? false : true
			};

			await sendBroadcastClickStreamEngagement ( params );

		} catch ( e ) {
			return;
		}

	};

	const disableTheatreMode = () => {
		if ( theatreModeToggle )
			handleTheatreMode ();
	};

	const handlePipMode = toggleStatus => {
		const sessionData = data;
		const freeStream  = sessionData.streamTier?.toString () !== STREAM_TIER.PRO_STREAM && sessionData.streamTier?.toString () !== STREAM_TIER.MID_STREAM;

		if ( !toggleStatus ) {
			togglePipModeVideo ( {
				status     : false,
				sessionId  : undefined,
				sessionSrc : undefined
			} );
		} else if (
			sessionData &&
      sessionData.cdnUrl &&
      !sessionData.endTimeUTC &&
      !sessionData.endedAt &&
      freeStream
		) {
			togglePipModeVideo ( {
				status     : true,
				sessionId  : sessionData.id,
				sessionSrc : sessionData.cdnUrl,
				actorName  : sessionData.broadcaster.sportsFan.name,
				thumbnail  : sessionData.thumbnail,
				streamTier : sessionData.streamTier
			} );
		}
	};

	/* const updateSessionFunc = useCallback ( data => {
      if ( !data )
        return;

      setDynamicData ( data );
      updateDynamicData ( data );
    }, [] ); */

	/* const updateSessionThrottle = useMemo ( () => {
    return throttle ( updateSessionFunc, 500 );
  }, [] ); */

	/* const handleReactions = data => {
    setReactions ( prev => {
      if ( !prev[data.id] ) {
        return {
          ...prev,
          [data.id]: {
            previousCount : data.reactionCount,
            showCount     : 0
          }
        };
      }

      return {
        ...prev,
        [data.id]: {
          previousCount : data.reactionCount,
          showCount     : data.reactionCount - prev[data.id].previousCount
        }
      };
    } );
  }; */

	const handleTheatreMode = () => {
		setToggleTheatreMode ( !theatreModeToggle );
	};

	return (
		<Presentation
			broadcastData = { data }
			broadcastId = { broadcastId }
			handleTheatreMode = { handleTheatreMode }
			isBlockedByStreamer = { isBlockedByStreamer }
			isStreamer = { isStreamer }
			sessionData = { dynamicData }
			staticTotalComments = { staticTotalComments }
			staticTotalReactions = { staticTotalReactions }
			theatreModeToggle = { theatreModeToggle }
			totalReactions = { totalReactions }
		/>
	);
};

export default component;
